import { makeStyles } from '@material-ui/core/styles';
import { COLORS } from '../constants';

/**
 * Estilos compartidos para las tarjetas de métricas (ImplementationCard y ParticipationCard)
 * Centraliza los estilos comunes para evitar duplicación
 */
export const useCardStyles = makeStyles((theme) => ({
    card: {
        padding: theme.spacing(2.5),
        borderRadius: '12px',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
    },
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        marginBottom: theme.spacing(1),
    },
    title: {
        fontWeight: 'bold',
        fontSize: '18px',
        color: COLORS.textPrimary,
    },
    subtitle: {
        color: COLORS.textSecondary,
        fontSize: '14px',
    },
    iconButton: {
        color: theme.palette.primary.main,
        cursor: 'pointer',
    },
    mainMetric: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
    },
    metricValue: {
        fontSize: '24px',
        fontWeight: 'bold',
        color: COLORS.textPrimary,
    },
    metricLabel: {
        fontSize: '14px',
        color: COLORS.textSecondary,
    },
    statsRow: {
        display: 'flex',
        alignItems: 'center',
        marginTop: theme.spacing(1),
        gap: theme.spacing(1),
    },
    percentageIcon: {
        marginRight: '4px',
    },
    warningRow: {
        display: 'flex',
        alignItems: 'center',
        marginTop: theme.spacing(1.5),
        gap: theme.spacing(1),
    },
    warningIcon: {
        fontSize: '20px',
    },
    warningValue: {
        fontWeight: 'bold',
        fontSize: '16px',
    },
    warningLabel: {
        color: COLORS.textSecondary,
        fontSize: '13px',
    },
    detailsLink: {
        marginTop: 'auto',
        paddingTop: theme.spacing(1),
        display: 'flex',
        justifyContent: 'flex-end',
    },
}));

export default useCardStyles;
